import { render, staticRenderFns } from "./NewLoginOTP.vue?vue&type=template&id=0e23498b&scoped=true"
import script from "./NewLoginOTP.vue?vue&type=script&lang=js"
export * from "./NewLoginOTP.vue?vue&type=script&lang=js"
import style0 from "./NewLoginOTP.vue?vue&type=style&index=0&id=0e23498b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e23498b",
  null
  
)

export default component.exports